/* eslint-disable no-underscore-dangle */
import Promise from 'bluebird';

import deps from './dependencies.json';

// This list includes all the dependencies that are synchronously loaded by some libraries
const preloadDeps = [
  'PageContext',
  'component/config/index',
  'instrumentation/log',
];

const logError = (err) => {
  window.console.error(err);
  throw err; // throw to make sure that window.onError event catch it and log this from aria
};

window.require.onError = logError;

let webpackDepsPromiseResolve;
window.webpackDepsPromise = new Promise((resolve) => {
  webpackDepsPromiseResolve = resolve;
});

const init = () => {
  window.require(
    [...preloadDeps, ...deps],
    () => {
      window.performance.mark('WebpackAppDependencyPerfMark-root');
      webpackDepsPromiseResolve();
    },
    logError
  );
};

init();
